import React, { Component } from 'react';
import artificialintelligencebg11 from "../../images/artificialintelligencebg11.jpg";
import './imageGroup.scss'
export class ImageGroupComponent extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);

    this.state = {
      cur: 0
    }
  }
  timer = null
  handleClick = () => {
    sessionStorage.setItem('tabactive', this.props.tabactive)
  }

  handleLoaded() {
    clearInterval(this.timer)

    this.timer = setInterval(() => {
      let newCur = this.state.cur + 1

      if (newCur > this.props.group.length - 1) {
        newCur = 0
      }

      this.setState({
        cur: newCur
      })
    }, 2000);
  }

  maxShow = 222

  render() {
    const {
      cur
    } = this.state

    return (
      <div className='image-group image-group-component'>
        <img
          className="latestdeveimg2"
          style={{ display: 'none' }}
          onLoad={this.handleLoaded.bind(this)}
          src={artificialintelligencebg11}
          alt=""
        ></img>
        {
          this.props.group.map((item, index) => {
            if (Math.abs(index - cur) <= Math.floor(this.maxShow / 2)) {
              return <img className="image" key={item} src={item} alt="" style={{ opacity: cur === index ? 1 : 0 }} />
            } else {
              return ''
            }
          })
        }

        <img style={{ opacity: 0, display: 'block', width: '100%' }} src={this.props.group[0]} alt="" />
      </div>
    );
  }
}

export default ImageGroupComponent;